
//Libraries
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "AccountData",
  setup() {
    //Data

    const isLoading = ref<boolean>(true);

    //Methods

    const getData = async (): Promise<any> => {
      return true;
    };

    //Lifecycle Hooks

    onMounted(() => {
      getData().then(() => {
        setTimeout(() => {
          isLoading.value = false;
        }, 1000);
      });
    });

    return {
      //Data
      isLoading,
    };
  },
});
